<template>
  <div>
    <template v-if="bValidarInternet">
      <v-row justify="center" v-if="!bErrorPermisos">
        <v-col v-if="bCargando" cols="12" class="mt-5" >
          <v-progress-linear indeterminate color="titlesdark darken-2" />
          <v-skeleton-loader
            type="article, actions"
          ></v-skeleton-loader>
  
          <v-skeleton-loader
            type="table-heading, list-item-two-line, image, table-tfoot"
          ></v-skeleton-loader>
        </v-col>
        <v-card v-else class="my-5 mx-5">
          <v-card-text class="pa-2" v-if="bMostarFormulario">
            <v-row class="no-gutters">
              <v-row class="no-gutters" >
                <v-col sm="12" :cols="campo.cols"  v-for="(campo, index) in aFormulario" :key="index +campo.AsValorEnviar +nKeyCleanCampos"  class="pa-1 ma-0" v-show="onValidarSubFormulario(campo)"  :style="!campo?.visible ? estiloOculto : {}">
                  <!-- Validamos si es el boton de envio o no -->
                  <template v-if="campo.Tipo=='boton'">
                    <v-btn 
                        @click="onClickBotonEnviar(campo,campo?.ModoCampo)" 
                        :class="['white--text', 'my-5']" 
                        color="#63A9E7" 
                        block
                        :disabled="bEnviandoFormulario"
                      >
                        <!-- Cambiar el texto del botón si está cargando -->
                        <template v-if="bEnviandoFormulario">Cargando...</template>
                        <template v-else>
                          <template v-if="campo.Label!=''&&campo.Label!=null">{{getEquivalencia(campo.Label)}}</template>
                          <template v-else>Enviar</template>
                        </template>
                      </v-btn>
                  </template>
                  <template v-else-if="onValidarSubFormulario(campo)">
                    <component 
                      v-if="campo.Tipo"
                      :key="nKeyCleanCampos"
                      :ref="`form-${campo.AsValorEnviar}`"
                      :is="campo.Tipo"
                      v-model="oFormCampos[campo.AsValorEnviar]"
                      :sLabel="getEquivalencia(campo.Label)"
                      :bObligatorio="campo.Obligatorio == 1 ? true : false"
                      :sCondicion="campo.Condicion"
                      :sCampoFiltro="campo.Filtro"
                      :nFiltro="campo.nFiltro"
                      :valorFiltro="campo.ValorFiltro"
                      :sCampoModificaA="campo.ModificaA"
                      :sCampoItem="campo.Campo"
                      :sGrupo="campo.sGrupo"
                      :bEditable="campo.bEditable"
                      :sModoCampo="campo.ModoCampo"
                      :sIdItem="campo.idValorSeleccionar"
                      @modificaA="onModificarCampo"
                      @input="onInputCampo(campo, $event)"
                      :sTabla="campo.sTabla"
                      :aOpciones="onTransformarJSON(campo.sTabla)"
                      :oDataExtra = "campo"
                      :bError = "campo.bError"
                      :id="campo.Orden"
                      />
  
                  </template>
                </v-col>
              </v-row>
            </v-row>
          </v-card-text>
        </v-card>
        <modalError v-model="bModalError" :aListaErrores="aListaErrores"/>
        <ModalMensaje v-model="oModalMensaje.bModalVisible" :sMensaje="oModalMensaje.sMensaje" :nTipo="oModalMensaje.nTipo"/>
        <DialogEnviarElementosExtraviados @onValidacionModal="onValidacionModalElementos" v-model="oModalDetalleElementos.bModalVisible" :oModalDetalleElementos="oModalDetalleElementos.oModalDetalleElementos"/>
      </v-row>
      <v-row justify="center" v-else>
        <v-alert 
          color="red"
          icon="mdi-alert-outline"
          class="mt-5"
          type="error"
        > Los permisos de GPS no son correctos </v-alert>
      </v-row>
    </template>
    <template v-else>
      <v-card-text>
        <v-row class="justify-center text-center">
            <!-- Icono dentro de un círculo gris -->
            <v-col cols="12">
              <div
                  class="d-inline-flex align-center justify-center"
                  style="
                  width: 80px;
                  height: 80px;
                  border-radius: 50%;
                  background-color: #e0e0e0;
                  margin: 0 auto;
                  "
              >
                  <v-icon
                  large
                  style="font-size: 40px;"
                  color="red"
                  >
                  mdi-wifi-off
                  </v-icon>
              </div>
            </v-col>
            <v-col cols="12" class="text-h6 font-weight-medium  mb-0 pb-0">
              Sin conexión
            </v-col>
            <v-col cols="12" class="text-subtitle-1 grey--text mt-0 pt-0">
              No se pudo completar la acción. Verifica tu conexión a internet e intenta nuevamente.
            </v-col>
            <v-col cols="12" class="text-h6 font-weight-medium  mb-0 pb-0">
              <v-btn 
                @click="onClickBotonEnviarSinInternet()" 
                :class="['white--text', 'my-5']" 
                color="primary" 
                block
              >
              Reintentar
              </v-btn>
            </v-col>
        </v-row>
    </v-card-text>
    </template>
  </div>
</template>

<script>

import selector from '@/components/Form/Componentes/FormSelect.vue';
import texto from '@/components/Form/Componentes/FormTexto.vue';
import textoArea from '@/components/Form/Componentes/FormTextArea.vue';
import radioButton from '@/components/Form/Componentes/FormRadioButton.vue';
import numero from '@/components/Form/Componentes/FormNumero.vue';
import tituloLabel from '@/components/Form/Componentes/FormLabelTitulo.vue';
import copiaCorreo from '@/components/Form/Componentes/FormCorreo.vue';
import descripcionLabel from '@/components/Form/Componentes/FormLabelDescripcion.vue';
import subFormulario from '@/components/Form/Componentes/FormSub.vue';
import foto from '@/components/Form/Componentes/FormFoto.vue';
import grupo from '@/components/Form/Componentes/FormGrupo.vue';
import busqueda from '@/components/Form/Componentes/FormBusqueda.vue';
import firma from '@/components/Form/Componentes/FormFirma.vue';
import modalError from '@/components/Form/Componentes/ModalError.vue';
import DialogEnviarElementosExtraviados from '@/components/DialogEnviarElementosExtraviados.vue';
import GPSLocation from '@/utils/GPSlocation.js';
import HoraFecha from "@/utils/Hora_Fecha.js";
import {mapGetters} from 'vuex'
import APPutils from '@/utils/APPutils.js'
import axiosServices from "@/services/axiosServices.js"

export default {
  name:'Form',
  components: {
    selector,
    texto,
    tituloLabel,
    copiaCorreo,
    descripcionLabel,
    subFormulario,
    foto,
    firma,
    modalError,
    numero,
    textoArea,
    radioButton,
    grupo,
    busqueda,
    DialogEnviarElementosExtraviados
  },
  props: {
    idMovilApp: {
      type: Number,
      defaul: 0
    },
    bInternet: {
      type: Boolean,
      defaul: false
    },
  },
  data() {
    return {
      bCargando       : true,                            // empleada para indicar que el form esta bCargando
      aFormulario         : [],                               // arreglo de campos del formulario  
      oFormCampos     : {},
      btnEnable       : false,
      aErroresMensaje : [],                               // Arreglo de mensajes para la plataforma,
      tituloForm      : '' , 
      nKeyCleanCampos : 0,                                // Indice que se incrementa para indicar que se limpiaron los campos y que debe refrescar.
      oModalMensaje:{
        bModalVisible:false,
        sMensaje:'',
        nTipo:1
      },
      bMostrarErrores:false,
      aCampos : [],               //Campos de los que se usan en el formulario
      aListaErrores:[],
      bModalError:false,
      oLocation : {},
      bErrorPermisos : false ,
      bEnviandoFormulario:false,
      disabledGuardar:false,
      sGrupoSeleccionado:"",
      bMostarFormulario:true,
      estiloOculto: {
        display: 'none',
        height: '0',
        width: '0',
        padding: '0',
        margin: '0',
        border: '0',
        overflow: 'hidden',
        position: 'absolute',
        visibility: 'hidden'
      },
      oModalDetalleElementos:{
        bModalVisible:false,
        oModalDetalleElementos:{}
      },
      oBotonTemporal:{},
      bValidarInternet:true
    }
  },
  async mounted(){
    // await this.loadDataEdit()
    await this.getGPSLocation();
    await this.getCampos();
    this.bCargando = false;
    await this.cargarFormulario();
    await this.sleep(7);
    //Despues de los 5 segundo validamos si no se cargo volverlo a llamar
    this.onActualizarComponentes();
  },
  methods: {
    onClickBotonEnviarSinInternet(){
      //Validamos si tiene internet
      if (navigator.onLine) {
        this.bValidarInternet=true;
        this.onEnviarFormulario(this.oBotonTemporal,this.oBotonTemporal.ModoCampo);
      } else {
        this.bValidarInternet=false;
        return;
      }
    },
    async onActualizarComponentes(){
      // Esperamos a que Vue renderice los componentes dinámicos
      if (this.aFormulario?.length > 0) {
        for (const oForm of this.aFormulario) {
          if (oForm.AsValorEnviar != null) {
            const oRefTemp = this.$refs['form-' + oForm.AsValorEnviar];
            if (oRefTemp==undefined) {
              this.cargarFormulario();
            }

            break; // rompe el ciclo después del primer AsValorEnviar válido
          }
        }
      }

    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async getGPSLocation(){
      // valido que se tenga permisos de GPS para continuar
      try{
        this.oLocation = await GPSLocation.getCurrentPosition()
        this.bErrorPermisos = false
      }catch(e){
        if(e.message=='User denied Geolocation'){
          this.bErrorPermisos = true
        }
        // Si hay error capturo el objeto segun la Doc https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError
        APPutils.onGuardarLog("Error GeolocationPositionError: {code:"+e.code+", message:"+e.message+"}")
      } 

    },
    async cargarFormulario(){
      //Validamos que venga un idmovil 
      if(this.idMovilApp==0){
        return;
      }

      let aFormularios = [];

      //Valiadmos si se hace de forma offline o online
      if(this.bInternet){
        aFormularios = await this.onGetFormularioPeticion();
      }
      else{
        aFormularios = this.$store.state.dataBase.dataBase.find(item => item.tablaName=='FormularioApp')?.info;
      }
      this.aFormulario = aFormularios?.filter(item=> item.idMovilApp == this.idMovilApp).sort((a, b) => a.Orden - b.Orden);

      let sGrupoSeleccionadoTemp = "";
      for (let i = 0; i < this.aFormulario.length; i++) {
        this.aFormulario[i].cols =  this.aFormulario[i].Tamano; 
        this.aFormulario[i].sTabla =  this.aFormulario[i].Tabla; 
        this.aFormulario[i].Tipo = this.aCampos.find(item => item.idTipoCampoApp == this.aFormulario[i].idTipoCampoApp)?.Tipo;
        this.aFormulario[i].visible = true; 
        this.aFormulario[i].bError = false; 

        if(this.aFormulario[i].Tipo=='grupo'){
          sGrupoSeleccionadoTemp = this.aFormulario[i].Campo;          
        }
        this.aFormulario[i].sGrupo = sGrupoSeleccionadoTemp; 

        
        //Aprovechasmos el ciclo para agrupar los subFormularios
        if(this.aFormulario[i].idTipoCampoApp=="8"&&(this.aFormulario[i].idSubTipoCampoApp=="0"||this.aFormulario[i].idSubTipoCampoApp==null)){
          //Obtenemos cual es el indentificador del formulario
          let sIdentificadorSub = this.aFormulario[i].ModificaA;

          //Obtenemos todos los subFormularios que tengan dicho identificador
          let aSubFormularios = this.aFormulario.filter(item => item.FiltroSub==sIdentificadorSub);
          this.aFormulario[i].aSubFormulario = aSubFormularios;
        }

        this.aFormulario[i].bEditable = true;
        
        //Validamos las condiciones de los campos
        if(this.aFormulario[i].Condiciones!=""&&this.aFormulario[i].Condiciones!=null){
          switch (this.aFormulario[i].idTipoCampoApp) {
            case "4":
                if(this.aFormulario[i].Condiciones?.includes("==")){
                  //Obtenemos la variable a la que quiere igualar del localstorage
                  let aVariable = this.aFormulario[i].Condiciones?.split("==");
                  let sValor = this.$store.state[aVariable[1]];
                  //Validamos que si no consigio data y es la sede la consultamos desde la app
                  if(sValor=="0"||!sValor||sValor==null){
                    
                    if(aVariable[1]=="nIDSedeBase"){
                      sValor = APPutils.onGetIdSede();
                    }
                  }
                  
                  this.oFormCampos[this.aFormulario[i].AsValorEnviar] = sValor.toString();
                  this.aFormulario[i].bEditable = false;
                  
                }
              break;
          
            default:
              break;
          }
        }
      }      

      //Validamos que si existe almenos un grupo oculatamos todo lo que tenga un grupo asignado, ya que significa que hay algun componente que selecciona dicho grupo
      for (let i = 0; i < this.aFormulario.length; i++) {
        if(sGrupoSeleccionadoTemp!=""&&this.aFormulario[i]?.sGrupo!=""){
          this.aFormulario[i].visible = false; 
        }
      }
    },
    getCampos(){
      //Valiadmos si se hace de forma offline o online
      if(this.bInternet){
        this.onGetCamposPeticion();
      }
      else{
        this.aCampos = this.$store.state.dataBase.dataBase.find(item => item.tablaName=='TipoCampoApp')?.info;
      }
    },
    async onGetCamposPeticion(){
      await axiosServices.getConfiguration(`/formularioPWA_TiposCampos`, true )
      .then(aItems =>{
          this.aCampos = aItems.aData;
      })
    },
    async onGetFormularioPeticion(){
      let oResultTemp = await axiosServices.getConfiguration(`/formularioPWA_Formulario`, true, `idMovilApp=${this.idMovilApp}`);
      return oResultTemp.aData;
    },
    onValidarSubFormulario(oItem){
      //Valida si es un subformulario para que no se muestre en el inicio
      if(oItem.idTipoCampoApp=="8"&&oItem.idSubTipoCampoApp!="0"){
        return false;
      }
      return true;
    },
    onLimpiarCampos(){

    },
    onEliminarBase64(obj) {
        // Si el objeto es un array, recorrerlo
        if (Array.isArray(obj)) {
            obj.forEach(item => this.onEliminarBase64(item)); // Llamar la función recursiva para cada elemento
        } else if (typeof obj === 'object' && obj !== null) {
            // Si el objeto es un objeto, recorrer sus propiedades
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    // Verificar si la propiedad es 'Firma', en ese caso no eliminar nada dentro de ella
                    if (obj?.Firma) {
                        // Recorrer recursivamente dentro de la propiedad Firma sin eliminar el Base64
                        this.onEliminarBase64(obj[key]);
                    } else {
                        // Si encontramos una propiedad que contiene Base64, la eliminamos
                        if (key === 'Base64') {
                            delete obj[key];
                        } else {
                            // Llamar recursivamente en la propiedad del objeto
                            this.onEliminarBase64(obj[key]);
                        }
                    }
                }
            }
        }
    },
    onValidarCampos(){
      //Validmos el formulario que los campos que son obligatorios esten completos
      this.aListaErrores =  [];
      this.aFormulario.forEach((oFormTemp, index) => {
        //Validamos si es un JSON
        let sLabelTemp = this.onTransformarJSON(oFormTemp?.Label);

        //Checamos si el label tiene estructura de $$, para solo escoger el primer dato que hace referncia al label
        if(sLabelTemp?.label){
          sLabelTemp = this.getEquivalencia(sLabelTemp?.label);
        }
        else if(oFormTemp.Label?.includes("$$")){
          sLabelTemp = this.getEquivalencia(oFormTemp?.Label?.split("$$")[0]);
        }
        else{
          sLabelTemp = this.getEquivalencia(oFormTemp.Label);
        }
        if(oFormTemp.Obligatorio=="1"&&(oFormTemp.idSubTipoCampoApp=="0"||oFormTemp.idSubTipoCampoApp==null)&&oFormTemp?.visible==true){
          //Validamos si es una fotografia o firma
          if(this.oFormCampos[oFormTemp.AsValorEnviar]?.TextoRespuesta&&this.oFormCampos[oFormTemp.AsValorEnviar]?.TextoRespuesta?.length==0){
            this.aFormulario[index].bError = true;
            this.aListaErrores.push(sLabelTemp);
          }
          //Validamos que el campo no este vacio
          else if(this.oFormCampos[oFormTemp.AsValorEnviar]==""||this.oFormCampos[oFormTemp.AsValorEnviar]==undefined){
            this.aFormulario[index].bError = true;
            this.aListaErrores.push(sLabelTemp);
          }
          //Validamos si no es un elementoExtraviado valido
          else if(this.oFormCampos[oFormTemp.AsValorEnviar]?.length>0&&this.oFormCampos[oFormTemp.AsValorEnviar][0]?.idEstado){
            //Recorremos que no exista ningun elemento diferente al estado 1
            let bRecorrer = true;
            this.oFormCampos[oFormTemp.AsValorEnviar].forEach(oElemento => {
              if(!oElemento?.bOmitir && oElemento?.idEstado!="1" && bRecorrer){
                this.aFormulario[index].bError = true;
                this.aListaErrores.push(sLabelTemp);
                bRecorrer = false;
              }
            });
          }
        }
      });

      if(this.aListaErrores.length>0){
        this.bModalError=true;
        return false;
      }

      return true;
    },
    async onEnviarFormulario(oBoton, nTipoBoton){
      //Agregamos la fecha y las coordenadas
      this.oFormCampos.Fecha = HoraFecha.getNow();
      //Validamos si existe la longitud
      if(this.oLocation?.coords?.latitude){
        this.oFormCampos.Latitud = this.oLocation.coords.latitude;
        this.oFormCampos.Longitud = this.oLocation.coords.longitude;
      }
      else{
        this.oFormCampos.Latitud = 0;
        this.oFormCampos.Longitud = 0;
      }
      this.oFormCampos.nIdUser = this.getnIduser;
      
      //validamos si no mandamos la imagen ya que es por apk
      if(this.getisAPP&&nTipoBoton!="2") {
        this.onEliminarBase64(this.oFormCampos);
      }

      this.bEnviandoFormulario = true;
      let oResult = await this.$axiosServices.postConfiguration(oBoton.ModificaA, this.oFormCampos, true );

      if(this.getisAPP&&nTipoBoton!="2") {
        try {
          if(!Object.prototype.hasOwnProperty.call(oResult, 'nStatusCode')) {
            APPutils.enviarDataOffline(this.oFormCampos,'PWA',oBoton.ModificaA)
            this.disabledGuardar = false
          }else {
            if ((oResult.nStatusCode == 200) || (oResult.nStatusCode == 220)  ){
            APPutils.registro_OK()
            this.oFormCampos = {};
            this.nKeyCleanCampos++;
          } else {
            APPutils.enviarDataOffline(this.oFormCampos,'PWA',oBoton.ModificaA)
          }
          this.disabledGuardar = false
          }
          
        } catch(e) {
          /* eslint-disable no-console */
          console.log(e)
          APPutils.onGuardarLog("Error al enviar formulario:"+e)
          APPutils.enviarDataOffline(this.oFormCampos,'PWA',oBoton.ModificaA)
          this.disabledGuardar = false
        }
        
      }
      else{
        //Validamos si se guardao correctamente
        if(oResult?.sStatus=="success"){
          this.disabledGuardar = false
          if(nTipoBoton=='2'){
            await this.$swal({
              timer: 3500,
              icon: `success`,
              title: `${oResult.aData}`,
              showConfirmButton: false
            })
          }
          else{
            await this.$swal({
              timer: 3500,
              icon: `success`,
              title: `${oResult.sMessage}`,
              showConfirmButton: false
            })
          }
          this.oFormCampos = {};
          this.nKeyCleanCampos++;
        }
        else{
          this.oModalMensaje.bModalVisible = true
          this.oModalMensaje.sTitulo = 'Error en la peticion' 
          this.oModalMensaje.nTipo = 3;
          this.oModalMensaje.sMensaje = oResult?.sMessage
        }
      }
      this.disabledGuardar = false;
      this.bEnviandoFormulario = false;
      //Si el tipo es 2, recrgamos toda la vista para resetear todo correctamente
      if(nTipoBoton==2){
        // location.reload()
        // await this.getCampos();
        this.oModalDetalleElementos.bModalVisible = false;
        this.oFormCampos = {};
        this.aFormulario = [];

        await this.cargarFormulario();
      }
      
    },
    onClickBotonEnviar(oBoton,nTipoBoton){
      this.oBotonTemporal = oBoton;

      if(nTipoBoton==undefined || nTipoBoton == null){
        nTipoBoton = "1";
      }

      if(!this.onValidarCampos()){
        return;
      }
      
      //Validamos si tiene internet
      if (navigator.onLine) {
        this.bValidarInternet=true;
      } else {
        this.bValidarInternet=false;
        return;
      }

      //Validamos que tipo de boton es
      if(nTipoBoton=="1"){
        this.onEnviarFormulario(oBoton,nTipoBoton)
      }
      else if(nTipoBoton=="2"){
        //Recorremos los selects, para mandar los nombres tambien
        this.aFormulario.forEach(aFormTemp => {
          if(aFormTemp?.idTipoCampoApp=="4"){
            let oRefTemp = this.$refs['form-' + aFormTemp.AsValorEnviar];
            if(oRefTemp){
              let oItemEncontrado = oRefTemp[0].aData.find(item => item[aFormTemp.idValorSeleccionar] == this.oFormCampos[aFormTemp.AsValorEnviar]);
              if(oItemEncontrado){
                let sDatoMostrar = oItemEncontrado[aFormTemp.Campo]
                this.oFormCampos[aFormTemp.AsValorEnviar+'Mostrar'] = sDatoMostrar;
              }
            }
          }
        });
        
        this.oModalDetalleElementos.oModalDetalleElementos = this.oFormCampos;
        
        
        //Si es tipo 2 hay varias validaciones antes de enviar el formulairo
        this.oModalDetalleElementos.bModalVisible = true;
      }
    },
    onModificarCampo(oDato){
      //Consultamos del formulario el dato al que le vamos a pasar el filtro
      let aFormularioTemp = this.aFormulario.find(item => item.sTabla == oDato.sCampoModificaA);
      if(aFormularioTemp!=undefined){
        aFormularioTemp.nFiltro = oDato.nId;
      }
      else{
        //Validamos si modifica a mas de un tipoCampo si tiene mas de 1 deberia estar separado por $
        let aCamposModificaA = oDato.sCampoModificaA?.split("$");
        let sCampoModificaA = ""; 
        if(aCamposModificaA?.length>0){
          //Validamos el grupo correspondiente a mostrar
          aCamposModificaA.forEach(sCampoModificaATemp => {
            if(sCampoModificaA==''){
              let oCampoTempModificaA = this.aFormulario.find(item => item.Campo == sCampoModificaATemp && item.Condiciones==`=${oDato.nId}` );
              if(oCampoTempModificaA?.Campo){
                sCampoModificaA = oCampoTempModificaA?.Campo;
              }
            }
          });
        }
        else{
          sCampoModificaA = aCamposModificaA[0];
        }
        //Obtenemos informacion del tipo de campo que queremos modificar
        let oCampoCompleto = this.aFormulario.find(item => item.Campo == sCampoModificaA);
        
        switch (oCampoCompleto.idTipoCampoApp) {
          case "14":
            //Obtenemos el grupo con el que queremos ahcer el filto de informacion
            
            //Campo grupo, vmaos a mostra o ocultar todos los componentes marcados con el campo al que estamos modificando
            //Recorremos todos los componentes para ver quien mostramos y quien no
            this.aFormulario = this.aFormulario.map(campo => {
              if(campo?.sGrupo){
                
                if(campo?.sGrupo==oCampoCompleto.Campo){
                  //validamos la condicion se vamos a ocultar o no
                  return { ...campo, visible: oCampoCompleto.Condiciones==`=${oDato.nId}` }
                }
                else if(!campo?.sGrupo||campo?.sGrupoo==""){
                  return { ...campo}
                }
                else if(campo?.sGrupo!=oCampoCompleto.Campo){
                  return { ...campo, visible: false }
                }
              }
              
              return { ...campo}
            })
            
            this.nKeyCleanCampos++;

            break;
          default:
            break;
        }
      }
      
    },
    getEquivalencia(sEquivalencia){
      if(sEquivalencia?.includes("??")){
        sEquivalencia = sEquivalencia.replaceAll("??", "");
        sEquivalencia = this.getoEquivalencia[sEquivalencia];
      }
      return sEquivalencia;
    },
    onTransformarJSON(sTexto) {
    try {
      let data = JSON.parse(sTexto);

      // Si después del primer parse sigue siendo string, parsea de nuevo
      if (typeof data === "string") {
        data = JSON.parse(data);
      }

      return data;
    } catch (error) {
      return sTexto;
    }
    },
    onValidacionModalElementos(bResult){
      if(bResult){
        this.onEnviarFormulario(this.oBotonTemporal,"2")
      }
      else{
        this.oModalDetalleElementos.bModalVisible = false;
      }
    },
    onInputCampo(oCampo, valor){
      oCampo.bError = false;
    }

  },
  computed: {
    ...mapGetters(['getlatlng','getoEquivalencia','getimei', 'getnIduser', 'getisAPP'])
  },
}
</script>

<style lang="scss"  scoped>
  .caja-desvanecido{
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 1;
    width: 100%;
    display: flex;
    justify-content: end;
    align-items:flex-end;
    .btn-vermas-infocard{
      margin: 0px 5px 5px 0px;
    }
  }
  .h-minimo-desvanecido{
    background: rgb(255,255,255);
    background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 12%, rgba(255,255,255,0.87718837535014) 33%, rgba(255,255,255,0) 100%);
  }
  .h-completo-desvanecido{
    background: none;
  }
  .h-completo{
    height: auto;
    overflow: auto;
    padding: 10px 10px 50px 10px!important;
    .caja-desvanecido{
      height: 40px;
      border-top: solid #e3e3e3 1px;
    }
  }
  .h-minimo{
    height: 200px;
    overflow: hidden;
    padding: 10px 10px 10px 10px!important;
    .caja-desvanecido{
      height: 80px;
      border-top: none;
    }
  }
  .info-text-cardexpander{
    font-size: 0.95em;
    line-height: 1.1em;
    margin: 0px;
    padding: 0px;
  }
  .info-text-cardexpander{
    font-size: 0.95em;
    line-height: 1.1em;
    margin: 0px;
    padding: 0px;
  }
.hidden-no-space {
  display: none !important;
  height: 0 !important;
  width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  visibility: hidden !important;
  position: absolute !important;
}
</style>